export const FINDINGS_PATH_NAME = 'findings';
export const REMEDIATION_CACHE_KEY_PREFIX = 'remediation:inProgress:';
export const REMEDIATION_REQUESTED_BY_CACHE_KEY_PREFIX =
  'remediation:requestedBy:';
